
import { getSessionInfo } from '@/utils/SessionInfo';
import { Component, Prop, Vue } from 'vue-property-decorator';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import { getModule } from 'vuex-module-decorators';
import Timer from 'easytimer.js';
const AppState = getModule(AppModule, store);
import { LOCK_CONST } from '@/constants';

// Maybe we want to define this as a shared type,
// if we will be doing dynamic style objects elsewhere
type StyleObject = {
    background?: String;
    backgroundColor?: String;
};

@Component
export default class Slide extends Vue {
    @Prop(String) backgroundImage!: string;
    @Prop({ type: String, default: 'no-repeat' }) backgroundRepeat!: string;
    @Prop({ type: String, default: 'cover' }) backgroundSize!: string;
    @Prop({ type: String, default: 'center' }) backgroundPosition!: string;
    @Prop({ type: Boolean, default: false }) enableScrollIndication!: boolean;
    @Prop(String) backgroundColor!: string;
    @Prop(String) hiddenTitle!: string;
    @Prop(String) accessibilityTitle?: string | null;
    isScrollable: boolean = false;
    showScrollSign: boolean = false;
    scrollDisplayTimout: any;
    timer!: Timer;
    isLockedPage: boolean = false;
    unlockedTime: number = 0;
    interactives: string[] = [];
    pageTitle: string = '';
    pageId: string = '';
    sessionInfo = getSessionInfo();

    public $refs!: {
        slideWrapper: HTMLFormElement;
    };
    mounted() {
      setTimeout(this.updateScrollStatus, 500);
      this.updateScrollStatus();
      window.addEventListener('resize', this.updateScrollStatus);
      this.$refs.slideWrapper.addEventListener(
        'scroll',
        this.hideScrollSignDisplay
      );
      this.resetScrollDisplayTimeout();
      this.isLockedPage = AppState.getLockMode !== LOCK_CONST.UNLOCKED;

      this.interactives = this.findInteractives();
      this.timer = new Timer();
      this.timer.start();

      store.watch(() => AppState.getLockMode, this.handleLockModeChange);

      // Caching Page information, to avoid misindentification on analysis
      this.pageId = AppState.getCurrentSlide;
      this.pageTitle = AppState.getCurrentSlideTitle;
    }
    beforeDestroy() {
      this.$refs.slideWrapper.removeEventListener(
        'scroll',
        this.hideScrollSignDisplay
      );
      window.removeEventListener('resize', this.updateScrollStatus);

      this.timer.reset();
    }
    updateScrollStatus() {
      if (!this.$refs.slideWrapper) return;
      this.isScrollable =
            this.$refs.slideWrapper.scrollHeight >
            this.$refs.slideWrapper.clientHeight;
      if (this.isScrollable) this.resetScrollDisplayTimeout();
    }
    showScrollSignDisplay() {
      this.showScrollSign = true;
    }
    hideScrollSignDisplay() {
      clearTimeout(this.scrollDisplayTimout);
      this.showScrollSign = false;
    }
    resetScrollDisplayTimeout() {
      clearTimeout(this.scrollDisplayTimout);
      this.scrollDisplayTimout = setTimeout(this.showScrollSignDisplay, 5000);
    }

    handleLockModeChange(newStatus: number, OldStatus: number) {
      if (newStatus === LOCK_CONST.UNLOCKED && !this.unlockedTime)
        this.unlockedTime = this.timer.getTimeValues().seconds;
    }
    findInteractives(): string[] {
      // TODO: This is a very basic approuch and only covers imediate children of the slide. We may want to dig deeper if we find this information relevant.
      let result = this.$children.reduce((old: any, cur: any) => {
        if (cur.isInteractive) return [...old, cur.$options._componentTag];
      }, []) as string[];
      return result || [];
    }
    get computedStyles() {
      const {
        backgroundImage,
        backgroundRepeat,
        backgroundSize,
        backgroundPosition,
        backgroundColor
      } = this;

      const style: StyleObject = {};

      if (backgroundImage)
        style.background = `${backgroundRepeat} ${backgroundPosition}/${backgroundSize} url(${this.backgroundImage})`;

      if (backgroundColor) style.backgroundColor = backgroundColor;

      return style;
    }

    get slideTitle(): string {
      return this.accessibilityTitle ?? AppState.getCurrentSlideTitle;
    }
}
